// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"290":"dist/css/login-forms","590":"dist/css/app","638":"dist/css/base"}[chunkId] + ".css";
};